// TODO: handle sites & widget 404, currently it's used for home & app
// We can only have 1 shared 404 in 1 Next.js app
export { Custom404 as default } from '@chirpy-dev/ui';
